import { AssistanceItemData, RawAssistance, RawCoverage, DetailedCoverageItem, CoverageGroup } from "../../../shared/services/api/fire/types";

export const mapApiToItem = (a: RawAssistance): AssistanceItemData => ({
	key: `${a.assistanceId}:${a.category}`,
	label: a.description,
	enabled: a.status === "active",
	isDefault: Boolean(a.ass_default),
	id: a.id,
	assistanceId: a.assistanceId,
	category: (a.category as any) === "commercial" ? "commercial" : "residential",
});

export const mapItemToApi = (i: AssistanceItemData) => ({
	id: i.id ?? "",
	assistanceId: i.assistanceId ?? "",
	category: (i.category as any) === "commercial" ? "commercial" : "residential",
	description: i.label,
	ass_default: !!i.isDefault,
	status: i.enabled ? "active" : "inactive",
});

export const mapApiToDetailedItem = (rawCoverages: RawCoverage[]): CoverageGroup[] => {
	if (!rawCoverages || rawCoverages.length === 0) {
		return [];
	}

	const formatValueToReal = (value: string | number | undefined): string => {
		// 1. Trata null/undefined e garante que é string
		const strValue = String(value ?? "0.00");
		// 2. Substitui ponto por vírgula para a VMaskTextField (Formato Real)
		return strValue.replace(".", ",");
	};

	const groupedCoverages: Record<string, CoverageGroup> = {};
	const addedCoverageIds: Record<string, Set<string>> = {};

	rawCoverages.forEach((raw) => {
		const riskGroup = raw.riskGroup;

		const groupId = riskGroup?.id;
		const groupName = riskGroup?.name;
		const groupCategory = riskGroup?.category; // Captura a categoria (Ex: 'residential')

		// 1. Geração da chave e label do grupo
		const groupKey = groupId ? `RISK_GROUP_${groupId}` : `UNKNOWN_${raw.id}`;
		const groupLabel = groupName ? groupName.toUpperCase() : "GRUPO DESCONHECIDO";

		// 2. Mapeamento para DetailedCoverageItem (o conteúdo da linha)
		const detailedItem: DetailedCoverageItem = {
			id: raw.id,
			coverageId: raw.coverageId,
			label: raw.name || `Cobertura ${raw.coverageId}`,
			description: `Categoria: ${raw.category || "N/A"}`,
			enabled: raw.status === "active",
			limite_min: formatValueToReal(raw.limite_min),
			maxValue: formatValueToReal(raw.limite_max),
			factor: String(raw.factor ?? "0"), // Fator é inteiro, não precisa de vírgula
			rateIncrease: formatValueToReal(raw.rate_increase),
			defaultValue: formatValueToReal(raw.limite_min),
			fieldType: "currency",
			name: raw.name || "",
		};

		if (!addedCoverageIds[groupKey]) {
			addedCoverageIds[groupKey] = new Set();
		}

		if (addedCoverageIds[groupKey].has(raw.id)) {
			return; // Ignora itens duplicados
		}

		addedCoverageIds[groupKey].add(raw.id);

		// Adiciona o item ao grupo
		if (groupedCoverages[groupKey]) {
			groupedCoverages[groupKey].coverages.push(detailedItem);
		} else {
			groupedCoverages[groupKey] = {
				groupKey: groupKey,
				groupLabel: groupLabel,
				category: groupCategory || "unknown", // Adiciona a categoria para filtro da aba
				coverages: [detailedItem],
			};
		}
	});

	return Object.values(groupedCoverages);
};

export const mapDetailedGroupsToApiPayload = (coverageGroups: CoverageGroup[]) => {
	const allCoverages = coverageGroups.flatMap((group) => group.coverages);

	return allCoverages.map((item) => ({
		id: item.id,
		coverageId: item.coverageId,
		limite_min: item.limite_min,
		limite_max: item.maxValue,
		factor: item.factor,
		rate_increase: item.rateIncrease,
		status: item.enabled ? "active" : "inactive",
		name: item.name,
	}));
};
